import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { type FC } from 'react';
import { format } from 'date-fns';
import common from 'constants/common';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';
import useUser from 'utils/useUser';
import { useCheckRoleAccess } from 'infrastructure/hooks';

import ModuleItem from './moduleItem';
import ClinicReviewTime from './clinicReviewTime';
import s from './styles.module.scss';

import type { Res as IModuleData } from '../../hooks';

interface Props {
  clinicReviewTimeSeconds?: number;
  loading: boolean;
  addLoading: boolean;
  today: Date;
  rpmData?: IModuleData;
  ccmData?: IModuleData;
  onAdd: () => void;
}

const CombinedInteractiveTime: FC<Props> = ({
  clinicReviewTimeSeconds,
  addLoading,
  loading,
  today,
  ccmData,
  rpmData,
  onAdd,
}) => {
  const { t } = useTranslation();
  const { isPractice, isAdmin } = useUser();
  const { isReadOnlyRole } = useCheckRoleAccess();

  return (
    <div className={s.combined} id="interaction-time">
      <BaseSpinWrapper spinning={loading}>
        <div className={s['combined-wrapper']} data-cy="interactive-time-block">
          <div className={s['combined-title-wrapper']}>
            <h4 className={s['combined-title']}>
              {t('controls.interactiveTime')}
            </h4>
            <p className={s['combined-month']}>
              {format(today, common.dateFormats.interactiveTime)}
            </p>
          </div>
          <div className={s['combined-modules']}>
            {rpmData && (
              <ModuleItem
                clinicTime={rpmData.clinicTime}
                totalTime={rpmData.totalTime}
                isRpm
              />
            )}
            {ccmData && (
              <ModuleItem
                clinicTime={ccmData.clinicTime}
                totalTime={ccmData.totalTime}
                isRpm={false}
              />
            )}
            {typeof clinicReviewTimeSeconds === 'number' && (
              <ClinicReviewTime
                clinicReviewTimeSeconds={clinicReviewTimeSeconds}
              />
            )}
          </div>
          <div className={s['combined-btn-wrapper']}>
            {(isPractice || isAdmin) && (
              <BaseButton
                label={t('labels.addTime')}
                dataCy="add-manual-time-button"
                onClick={onAdd}
                loading={addLoading}
                disabled={isReadOnlyRole || addLoading}
              />
            )}
          </div>
        </div>
      </BaseSpinWrapper>
    </div>
  );
};

export default CombinedInteractiveTime;
